// String values are sent to telemetry and stored against the association, so they
// have to stay exactly as they are.
export enum TrailerSelectionMethod {
    manual = 'Manual',
    qrScan = 'QrScan',
    find = 'Find',
    select = 'Select',
}
